// @gs/feedback/client — libelles lisibles de l'app d'origine (originBcKey).
// Table locale au module (le feedback ne connait pas la nav de l'hote). i18n FR+EN
// via feedback:originApp.* ; fallback sur la cle brute pour modules hors liste.

/** Apps consommatrices du module feedback — facettes filtre « Toutes les apps ». */
export const FEEDBACK_ORIGIN_APP_FILTER_KEYS = ['ADM', 'HUB', 'INV', 'GEST', 'UG'] as const;

export type FeedbackOriginAppKey = (typeof FEEDBACK_ORIGIN_APP_FILTER_KEYS)[number];

const ORIGIN_BC_ALIASES: Record<string, FeedbackOriginAppKey | 'ADM' | 'HUB' | 'INV' | 'GEST' | 'UG'> = {
  ADMIN: 'ADM',
  admin: 'ADM',
  ADM: 'ADM',
  HUB: 'HUB',
  hub: 'HUB',
  INV: 'INV',
  inv: 'INV',
  GEST: 'GEST',
  gest: 'GEST',
  UG: 'UG',
  ug: 'UG',
};

const KNOWN_KEYS = new Set<string>(FEEDBACK_ORIGIN_APP_FILTER_KEYS);

/** Normalise origin_bc_key (alias legacy ADMIN, casse libre) vers une cle canonique. */
export function normalizeOriginBcKey(key: string): string {
  return ORIGIN_BC_ALIASES[key] ?? key.toUpperCase();
}

/** Cle i18n feedback:originApp.* pour un originBcKey (unknown + interpolation key). */
export function originAppI18nKey(originBcKey: string): string {
  const norm = normalizeOriginBcKey(originBcKey);
  if (KNOWN_KEYS.has(norm)) return `feedback:originApp.${norm}`;
  return 'feedback:originApp.unknown';
}

/** Libelle lisible pour un originBcKey (helper PUR — passe `t` de useTranslation). */
export function originAppLabel(
  t: (key: string, opts?: Record<string, string>) => string,
  originBcKey: string,
): string {
  const i18nKey = originAppI18nKey(originBcKey);
  if (i18nKey === 'feedback:originApp.unknown') return t(i18nKey, { key: originBcKey });
  return t(i18nKey);
}
